// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bboixtdnauxuqzxahiju.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJib2l4dGRuYXV4dXF6eGFoaWp1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM1NDIyOTQsImV4cCI6MjA4OTExODI5NH0.VBUNaBUU3isivuqOWQrZ4uvFVWy7-XmWtTwmWAFmBqw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});